import { translateText } from '@/locales/text'
import message from 'ant-design-vue/es/message'
// import defaultSettings from '../defaultSettings';
import themeColor from './themeColor.js'

// let lessNodesAppended
const colorList = [
  {
    get key () { return translateText('薄暮') }, color: '#F5222D'
  },
  {
    get key () { return translateText('火山') }, color: '#FA541C'
  },
  {
    get key () { return translateText('日暮') }, color: '#FAAD14'
  },
  {
    get key () { return translateText('明青') }, color: '#13C2C2'
  },
  {
    get key () { return translateText('极光绿') }, color: '#52C41A'
  },
  {
    get key () { return translateText('拂晓蓝（默认）') }, color: '#1890FF'
  },
  {
    get key () { return translateText('极客蓝') }, color: '#2F54EB'
  },
  {
    get key () { return translateText('酱紫') }, color: '#722ED1'
  }
]

const updateTheme = newPrimaryColor => {
  const hideMessage = message.loading(translateText('正在切换主题！'), 0)
  themeColor.changeColor(newPrimaryColor).then(r => {
    setTimeout(()=>{
      hideMessage()
    }, 10)
  })
}

const updateColorWeak = colorWeak => {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  const app = document.body.querySelector('#app')
  colorWeak ? app.classList.add('colorWeak') : app.classList.remove('colorWeak')
}

export { updateTheme, colorList, updateColorWeak }
